import ApiService from '@/common/api.service'
import JwtService from '@/common/jwt.service'
import {
  CHECK_AUTH,
  LOGIN,
  LOGOUT,
  RESET_AUTH_STATE,
  GET_PROFILE,
  GET_DASHBOARD,
  UPDATE_PROFILE,
  CHANGE_PASSWORD,
  FORGET_PASSWORD,
  RESET_PASSWORD
} from './actions.type'
import {
  SET_AUTH,
  SET_ERROR,
  PURGE_AUTH,
  RESET_STATE,
  SET_PROFILE,
  SET_DASHBOARD,
  SET_UPDATED_PROFILE,
  SET_IS_LOADING,
  SET_NEW_PASSWORD,
  SET_RESET_PASSWORD
} from './mutations.type'
import Progress from '@/common/progress'

const getDefaultState = () => {
  return {
    user: null,
    userProfile: null,
    isAuthenticated: !!JwtService.getUser(),
    isAdmin: false,
    dashboard: null,
    canAddFakeViewers: false,
    errors: null
  }
}

const state = getDefaultState()

const getters = {
  currentUser(state) {
    if (!state.user) {
      const user = JSON.parse(JwtService.getUser())
      return user
    } else {
      return state.user
    }
  },
  isAuthenticated(state) {
    return state.isAuthenticated
  },
  isAdmin(state) {
    if (state.isAuthenticated) {
      if (!state.user) {
        const user = JSON.parse(JwtService.getUser())
        return user.roles[0].role === 'admin'
      } else {
        return state.user.roles[0].role === 'admin'
      }
    }
    return null
  },
  isEditor(state) {
    if (state.isAuthenticated) {
      if (!state.user) {
        const user = JSON.parse(JwtService.getUser())
        return user.roles[0].role === 'content_editor'
      } else {
        return state.user.roles[0].role === 'content_editor'
      }
    }
    return null
  },
  isStreamer(state) {
    if (state.isAuthenticated) {
      if (!state.user) {
        const user = JSON.parse(JwtService.getUser())
        return user.roles[0].role === 'streamer'
      } else {
        return state.user.roles[0].role === 'streamer'
      }
    }
    return null
  },
  canAddFakeViewers(state) {
    let canAddFakeViewers = false
    if (state.isAuthenticated) {
      const user = JSON.parse(JwtService.getUser())

      if (user.roles) {
        user.roles.map(r => {
          if (r.role === 'can_update_viewer' || r.role === 'admin') {
            canAddFakeViewers = true
          }
        })
      }
    }
    return canAddFakeViewers
  }
}

const actions = {
  [CHECK_AUTH](context) {
    if (JwtService.getUser()) {
      ApiService.setHeader()
    } else {
      context.commit(PURGE_AUTH)
    }
  },
  [LOGIN](context, credentials) {
    Progress.show()
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/login', credentials)
        .then((response) => {
          Progress.hide()
          if (response.data) {
            context.commit(SET_AUTH, response.data)
            resolve(response.data)
          } else {
            context.commit(SET_AUTH, response)
            reject(response)
          }
        })
        .catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [GET_DASHBOARD](context) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/dashboard')
        .then(({ data }) => {
          context.commit(SET_DASHBOARD, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [UPDATE_PROFILE](context, user) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.put('api/v1/streamers/updateStreamer', user)
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_UPDATED_PROFILE, data)
          resolve()
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [GET_PROFILE](context) {
    return new Promise((resolve, reject) => {
      ApiService.get('api/v1/me')
        .then(({ data }) => {
          context.commit(SET_PROFILE, data)
          resolve(data)
        }).catch(({ response }) => {
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [CHANGE_PASSWORD](context, { email, oldPassword, newPassword }) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/changePassword', { email: email, oldPassword: oldPassword, newPassword: newPassword })
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_NEW_PASSWORD, data)
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response.data)
        })
    })
  },
  [FORGET_PASSWORD](context, email) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.post('api/v1/auth/reset-password', { email: email })
        .then(({ repsonse }) => {
          Progress.hide()
          resolve(repsonse.data)
        }).catch(({ data }) => {
          Progress.hide()
          reject(data)
        })
    })
  },
  [RESET_PASSWORD](context, { token, email, password }) {
    Progress.show()
    context.commit(SET_IS_LOADING, true)
    return new Promise((resolve, reject) => {
      ApiService.post(`api/v1/auth/confirm-reset-password/${token}`, { email: email, password: password })
        .then(({ data }) => {
          Progress.hide()
          context.commit(SET_RESET_PASSWORD, data)
          resolve(data)
        }).catch(({ response }) => {
          Progress.hide()
          context.commit(SET_ERROR, response.data)
          reject(response)
        })
    })
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH)
  },
  [RESET_AUTH_STATE](context) {
    context.commit(RESET_STATE)
  }
}

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error.message
  },
  [SET_AUTH](state, user) {
    if (user.roles) {
      state.isAuthenticated = true

      state.user = user
      state.errors = null
      JwtService.saveUser(JSON.stringify(state.user))
    } else {
      state.errors = { message: 'incorrect email or password ' }
    }
  },
  [SET_DASHBOARD](state, dashboard) {
    state.dashboard = dashboard
    state.errors = null
  },
  [SET_PROFILE](state, user) {
    if (user.roles) {
      user.roles.map(r => {
        if (r.role === 'can_update_viewer') {
          state.canAddFakeViewers = true
        }
      })
    }
    state.userProfile = user
    state.errors = null
  },
  [SET_UPDATED_PROFILE](state, response) {
    const currentUser = JSON.parse(JwtService.getUser())
    const token = currentUser.token
    const role = currentUser.roles
    state.user = response.user
    state.user.token = token
    state.user.role = role
    JwtService.saveUser(JSON.stringify(state.user))
  },
  [SET_NEW_PASSWORD](state, response) {
  },
  [SET_RESET_PASSWORD]() {
    state.errors = null
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false
    state.user = null
    state.errors = null
    JwtService.removeUser()
  },
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
